import catalog from './taskEntries.json';
import { tools } from './registry';
import type { ToolDefinition, ToolTaskEntry } from './types';

export const taskEntries = catalog as ToolTaskEntry[];

export const taskDefinitions: ToolDefinition[] = taskEntries.map((entry) => {
  const parent = tools.find((tool) => tool.id === entry.parentToolId);
  if (!parent) throw new Error(`任务入口 ${entry.slug} 缺少父工具 ${entry.parentToolId}`);
  return {
    ...parent,
    ...entry,
    entryKind: 'task',
    parentToolId: parent.id,
    status: 'available',
    loader: parent.loader,
  };
});

export function findTaskDefinition(slug: string): ToolDefinition | undefined {
  return taskDefinitions.find((entry) => entry.slug === slug);
}
